import {DataTableColumn} from "mantine-datatable";
import {NavLink} from "react-router-dom";
import {DeploymentAccountGroup} from "../types.ts";
import {I18n} from "@aws-amplify/core";


export const useDeploymentAccountGroupsTableColumns = () => {

    const columns: DataTableColumn<DeploymentAccountGroup>[] = [
        {
            accessor: 'name',
            title: I18n.get('Name'),
            width: '1fr',
            render: (item: DeploymentAccountGroup) => <NavLink
                to={`/deployment-account-groups/${item.id}`}>{item.name}</NavLink>,
        },
        {
            accessor: 'accounts',
            title: I18n.get('Accounts'),
            width: '1fr',
            render: (item: DeploymentAccountGroup) => item.accounts?.length || 0,
        },
    ];

    return {
        columns,
    };
};
